import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { msalInstance } from '../auth/msalConfig';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // handleRedirectPromise has already run in msalConfig.ts before React rendered.
    // By now the account cache is populated. Just send the user home.
    const accounts = msalInstance.getAllAccounts();
    console.log('[callback] accounts on mount:', accounts.map(a => a.username));
    if (accounts.length === 0) {
      console.warn('[callback] no accounts — redirecting to /login');
      void navigate({ to: '/login' });
    } else {
      console.log('[callback] navigating to /');
      void navigate({ to: '/' });
    }
  }, [navigate]);

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24 }}>
      <p>Signing you in&hellip;</p>
    </div>
  );
}
